export function show() {
  return { type: 'SHOW_LOADING' }
}

export function hide() {
  return { type: 'HIDE_LOADING' }
}
